import { signInWithEmailAndPassword, User } from "firebase/auth";
import { auth } from "./firebase";
import Caching from "../CacheManager";

export const logout = async () => {
  try {
    await auth.signOut();
    // localStorage.removeItem("idToken");
    Caching.clear();
    window.location.href = "/auth/login";
  } catch (error) {
    console.error("Error logging out:", error);
    throw error;
  }
};

// Log in with email and password
export const loginWithEmailPassword = async (
  email: string,
  password: string
): Promise<User | null> => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    if (userCredential.user.emailVerified === false) {
      throw new Error("Email not verified");
    }

    return userCredential.user;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};
